// The meeting whose page is open (set by MeetingDetail). While it is open, task requests carry its id
// (httpService), so the server lets that meeting's organiser and the attendees they let edit it change the
// tasks on its agenda. Nothing changes for task requests made anywhere else.
let current = null;

export const setMeetingContext = (id) => {
  current = Number(id) || null;
};

export const meetingContext = () => current;
